import {Component, HostListener, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import { Router } from '@angular/router';
import { ApiBackendService } from '../../shared/services/api-backend.service';
import { Category } from '../../shared/entities/category';
import { CookiesEditModalComponent } from '../../shared/components/cookies-edit-modal/cookies-edit-modal.component';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'gryf-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit {
  collapsed = false;
  isScrolled = false;
  darkIcon = false;
  categories: Category[];
  showNavbar: boolean = true;

  constructor(
    private router: Router,
    private apiBackendService: ApiBackendService,
    private matDialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.scrollY === 0) {
        this.isScrolled = false;
        this.darkIcon = this.router.url !== '/home';
      } else {
        this.isScrolled = true;
        this.darkIcon = true;
      }
    }
  }

  @HostListener('document:click', [ '$event.target' ]) clickedOutside($event) {
  }

  ngOnInit(): void {
    let urlSplit: string[] = null;
    if (this.router.url) {
      urlSplit = this.router.url.split('/');
      if (urlSplit && urlSplit[1]) {
        this.showNavbar = urlSplit[1].toString() !== 'e-offer';
      }
    }
    this.collapsed = false;
  }

  collapse(event) {
    this.collapsed = !this.collapsed;
    if (this.router.url === '/home' && isPlatformBrowser(this.platformId)) {
      if (!this.collapsed && window.scrollY === 0) {
        this.isScrolled = false;
        this.darkIcon = false;
        document.getElementById('navbar').classList.remove('navbar-light');
        document.getElementById('logo2').style.display = 'none';
        document.getElementById('logo1').style.display = 'block';
        document.getElementById('about').classList.remove('text-dark');
        document.getElementById('navbarProducts').classList.remove('text-dark');
        document.getElementById('navbarServices').classList.remove('text-dark');
        document.getElementById('navbarContacts').classList.remove('text-dark');
        document.getElementById('blog').classList.remove('text-dark');
        document.getElementById('ponuka').classList.remove('text-dark');
      } else if (this.collapsed) {
        this.darkIcon = true;
        document.getElementById('navbar').classList.add('navbar-light');
        document.getElementById('logo2').style.display = 'block';
        document.getElementById('logo1').style.display = 'none';
        document.getElementById('about').classList.add('text-dark');
        document.getElementById('navbarProducts').classList.add('text-dark');
        document.getElementById('navbarServices').classList.add('text-dark');
        document.getElementById('navbarContacts').classList.add('text-dark');
        document.getElementById('blog').classList.add('text-dark');
        document.getElementById('ponuka').classList.add('text-dark');
      } else {
        this.darkIcon = true;
      }
    }
  }

  closeNavBar(): void {
    this.collapsed = !this.collapsed;
    this.darkIcon = true;
    document.getElementById('navbarCollapse').classList.remove('show');
  }

  scrollTop(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

  openCookiesEditModal(): void {
    const dialogRef: MatDialogRef<CookiesEditModalComponent> = this.matDialog.open(CookiesEditModalComponent, {
      panelClass: 'cookies-edit-modal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        window.location.reload();
      }
    });
  }
}
